import { lazy } from 'react';

import CartographerPage from './components/CartographerPage';

const APIAccessPage = lazy(() => import('./components/APIAccessPage'));
const ComicPage = lazy(() => import('./components/ComicPage'));
const SwingPage = lazy(() => import('./components/SwingPage'));
const HermesPage = lazy(() => import('./components/HermesPage'));
const PosePage = lazy(() => import('./components/PosePage'));
const CharacterGenerationPage = lazy(
  () => import('./components/CharacterGenerationPage'),
);
const MotionLibraryPage = lazy(() => import('./components/MotionLibraryPage'));
const PropsPage = lazy(() => import('./components/PropsPage'));

export const products = [
  {
    name: 'API',
    title: 'Workflow Scaling\n and Automation',
    slug: 'api-access',
    page: <APIAccessPage />,
    useLightText: true,
    comingSoonText: '',
  },
  {
    name: 'Comic 3',
    title: 'AI Video\n Motion Capture',
    slug: 'comic-ai-video-motion-capture',
    page: <ComicPage />,
    useLightText: false,
    comingSoonText: '',
  },
  {
    name: 'Swing',
    title: 'Motion Generation',
    slug: 'swing-motion-generation',
    page: <SwingPage />,
    useLightText: false,
    comingSoonText: '',
  },
  {
    name: 'Hermes',
    title: 'Motion Blending & Editing',
    slug: 'hermes-smart-in-between',
    page: <HermesPage />,
    useLightText: false,
    comingSoonText: '',
  },
  {
    name: 'Pose',
    title: 'Character Rendering from Pose',
    slug: 'pose-render',
    page: <PosePage />,
    useLightText: true,
    comingSoonText: '',
  },
  {
    name: 'Character Generation',
    title: 'Image or Text-to-3D Characters',
    slug: 'character-generation',
    page: <CharacterGenerationPage />,
    useLightText: false,
    comingSoonText: '',
  },
  {
    name: 'Motion Library',
    title: 'Enterprise-Scale Motion Library',
    slug: 'motion-library',
    page: <MotionLibraryPage />,
    useLightText: false,
    comingSoonText: '',
  },
  {
    name: 'Cartographer',
    title: 'Universal Rig Retargeting',
    slug: 'cartographer',
    page: <CartographerPage />,
    useLightText: true,
    comingSoonText: 'Coming in March',
  },
  {
    name: 'Props',
    title: 'Object Motion Capture',
    slug: 'capture-transfer-object-motion',
    page: <PropsPage />,
    useLightText: true,
    comingSoonText: 'Coming soon',
  },
] as const;
